import React, { useState, useRef } from "react";
import { Formik, Field, Form } from "formik";
import * as Icons from "react-feather";
import { TextField, Loading, Select } from "components/form";
import { required, validationWrapper, number } from "lib/formValidations";
import { transformTranslateFromValues } from "lib/helpers";
import { Link, useNavigate } from "react-router-dom";
import { useList } from "store/list";
import { handleSuccessMessages } from "store/auth";

import AddSlide from "./AddSlide";
import { SortableContainer, SortableElement } from "react-sortable-hoc";
import { arrayMoveImmutable } from "array-move";
// components

export default function Add(props) {
  const path = {
    baseRoute: "/slider-panel",
    aliasName: "اسلاید ها",
    type: "Sliders",
  };
  const navigator = useNavigate();
  const { dispatch, clear, create } = useList();
  const [slides, setSlides] = useState([]);
  const [showAddSlide, setShowAddSlide] = useState(false);
  const onSortEnd = ({ oldIndex, newIndex }) => {
    let temp_slides = arrayMoveImmutable(slides, oldIndex, newIndex);
    temp_slides = temp_slides.map((item, index) => ({ ...item, order: index }));
    setSlides(temp_slides);
  };
  return (
    <>
      {/*add slide*/}
      <AddSlide
        slides={slides}
        setSlides={setSlides}
        show={showAddSlide}
        close={() => setShowAddSlide(false)}
        submit={(values) => {
          setSlides([...slides, values]);
        }}
      />
      {/*add slide*/}
      <div className="content">
        <div className="w-full p-3 flex justify-between items-center">
          <h2>ایجاد اسلایدر</h2>
          <Link to="/settings/sliders" className="btn btn-info shadow-md mr-2">
            بازگشت
          </Link>
        </div>

        <hr className="my-3" />
        <div className="p-3 w-full flex gap-x-2">
          <div className="w-1/4">
            <Formik
              initialValues={{}}
              onSubmit={async (values, { setSubmitting }) => {
                await dispatch(
                  create(path, { ...values, slides }, () => {
                    handleSuccessMessages("عملیات با موفقیت انجام شد");
                    navigator("/settings/sliders");
                  })
                );
                setSubmitting(false);
              }}
              enableReinitialize
            >
              {({ isSubmitting, dirty }) => (
                <Form>
                  <div className="box rounded py-3">
                    <div className="p-3">
                      <div className="intro-x flex-col">
                        <Field
                          placeholder="صفحه اسلایدر"
                          label="صفحه اسلایدر :"
                          name="type"
                          component={TextField}
                          // validate={(value) =>
                          //   validationWrapper(value, required)
                          // }
                        />
                        {/* <Field
                          placeholder="سرعت اسلایدر (ثانیه)"
                          label="سرعت اسلایدر (ثانیه) :"
                          name="transition_speed"
                          component={TextField}
                          validate={(value) =>
                            validationWrapper(value, required, number)
                          }
                        /> */}
                        {/* <div>
                          <Field
                            placeholder="نوع اسلایدر"
                            label="نوع اسلایدر :"
                            name="type"
                            component={Select}
                            validate={(value) =>
                              validationWrapper(value, required)
                            }
                            options={[
                              { value: "type_1", label: "نوع یک" },
                              { value: "type_2", label: "نوع دو" },
                              { value: "type_3", label: "نوع سه" },
                              { value: "type_4", label: "نوع چهار" },
                            ]}
                          />
                        </div> */}

                        <button
                          className="mt-4 btn btn-primary w-20"
                          type="submit"
                          disabled={!!(isSubmitting || !dirty)}
                        >
                          {isSubmitting ? <Loading /> : "ذخیره"}
                        </button>
                      </div>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>

          <div className="w-3/4">
            <div className="box p-2">
              <div className="flex justify-between md:px-4 items-center">
                <h3>اسلاید ها : </h3>
                <button
                  className="btn btn-primary btn-sm my-3"
                  onClick={() => {
                    setShowAddSlide(true);
                  }}
                >
                  ایجاد اسلاید
                </button>
              </div>
              <hr className="my-2" />

              {/* slides List */}
              <div className="mt-3">
                <div className="intro-y col-span-12 overflow-auto lg:overflow-visible">
                  <table className="table table-report text-xs -mt-2">
                    <thead>
                      <tr>
                        <th className="whitespace-nowrap text-center w-16">
                          اولویت
                        </th>

                        <th className="whitespace-nowrap text-center">
                          عنوان اسلاید
                        </th>

                        <th className="whitespace-nowrap text-center">
                          عملیات
                        </th>
                      </tr>
                    </thead>

                    {slides && slides.length > 0 && (
                      <SortableList
                        items={slides}
                        onSortEnd={onSortEnd}
                        removeItem={(item) => {
                          setSlides(slides.filter((i) => i.uuid != item.uuid));
                        }}
                      />
                    )}
                  </table>
                </div>
              </div>
              {/* slides List */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

const SortableList = SortableContainer((props) => {
  const { items } = props;

  return (
    <tbody>
      {items.map((item, index) => (
        <SortableItem
          key={`item-${index}`}
          index={index}
          item={item}
          removeItem={props.removeItem}
        />
      ))}
    </tbody>
  );
});
const SortableItem = SortableElement((props) => {
  const { item } = props;

  console.log("item: ", item);

  return (
    <tr className="intro-x cursor-pointer select-none">
      <td className="text-center">{item.order}</td>

      <td className="text-center">{item.translations.fa.title}</td>

      <td className="text-center">
        <button
          className="flex items-center text-theme-6 cursor-pointer"
          onClick={() => props.removeItem(item)}
        >
          <Icons.Trash2 className="w-4 h-4 ml-1 " />
          حذف
        </button>
      </td>
    </tr>
  );
});
